//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_Renaissance_&_Reformation.png';

const subTopics = [
  { name: 'Italian Renaissance', route: '/History-Italian-Renaissance', key: 'Italian Renaissance' },
  { name: 'Northern Renaissance', route: '/History-Northern-Renaissance', key: 'Northern Renaissance' },
  { name: 'Protestant Reformation', route: '/History-Protestant-Reformation', key: 'Protestant Reformation' },
  { name: 'Catholic Counter-Reformation', route: '/History-Catholic-Counter-Reformation', key: 'Catholic Counter-Reformation' },
  { name: 'Scientific Revolution', route: '/History-Scientific-Revolution', key: 'Scientific Revolution' }
];

function HistoryPageR() {
  return (
    <JourneyPage
      title="The Renaissance"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageR;
